export default {
    name: "neo-categorized",
    components: {},
    props: ["category"],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
